package org.moxultimate.topwithmox.apps.data

import kotlinx.serialization.Serializable

/**
 * AppsResponse
 * Maps the backend AppsEntity returned by GET /apps and GET /apps/{id}.
 * Matches the `apps` table columns directly.
 */
@Serializable
data class AppsResponse(
    val id: Long,
    val title: String? = null,
    val type: String? = null,
    val tags: String? = null,
    val description: String? = null,
    val imagePath: String? = null,
    val videoLink: String? = null,
    val createdAt: String? = null,
)
